/**
 * Replaces all not allowed characters by a blank space.
 *
 * Not allowed characters:
 * - Tab
 * - New line
 * - No-break space
 *
 * @param {string} value
 * @returns {string}
 */
export function replaceNotAllowedCharactersByBlankSpace(value) {
  return value.replace(/[\t\n\u00A0]/g, ' ');
}

/**
 * Replaces all sequences of five or more blank spaces by four blank spaces.
 * @param {string} value
 * @returns {string}
 */
export function replaceFiveOrMoreBlankSpacesByFour(value) {
  return value.replace(/[  ]{5,}/g, '    ');
}

/**
 * Sanitizes a string to be used in a Facebook template to avoid errors.
 * @param {string} value
 * @returns {string}
 */
export function sanitizeForFacebookTemplate(value) {
  return replaceFiveOrMoreBlankSpacesByFour(
    replaceNotAllowedCharactersByBlankSpace(value)
  );
}
